export enum GlobalVariableDocumentIds {
    RotoSchedule = 'roto-schedule',
    PrismLogo = 'prism-logo',
    BuildInfo = 'build-info',
    UserGroups = 'user-groups',
    RefreshClientDevices = 'refresh-client-devices',
    LaserProgramFilePaths = 'laser-program-file-paths',
    LaserProgramScheduleDict = 'laser-program-schedule-dict',
    ActivePlasticsScrapInstances = 'active-plastics-scrap-instances',
    OnsiteUtilitiesHeartbeat = 'onsite-utilities-heartbeat',
    BackupDataserverHeartbeat = 'backup-dataserver-heartbeat',
    AverageRotoScheduleMachineTallysPerDay = 'average-roto-schedule-machine-tallys-per-day',
    MetaltrackSchedule = 'metaltrack-schedule',
    KolorcansCustomerId = 'kolorcans-customer-id',
    KolorcansData = 'kolorcans-data',
    LaserProgramBaseFilePaths = 'laser-program-base-file-paths',
    ProcedureCAMData = 'procedure-cam-data',
    PlasticsHardwareItemShipmentDamageCAMData = 'plastics-hardware-item-shipment-damage-cam-data',
    ObsessedEngineeringComponentShipmentDamageCAMData = 'oe-component-shipment-damage-cam',
    FHCornerLabelConfig = 'fh-corner-label-config',
    SuncastData = 'suncast-data',
    ClackData = 'clack-data',
    LaserAssetLabelPrinterIdDict = 'laser-asset-label-printer-id-dict',
    PlasticsScrapAssetId = 'plastics-scrap-asset-id',
    SuncastRowProducts = 'suncast-row-products',
    AppwriteRealtimeTest = 'appwrite-realtime-test',
    ClusterDashboardStatus = 'cluster-dashboard-status',
    DockerContainerStats = 'docker-container-stats',
    MetalsQuoteParameters = 'metals-quote-parameters',
    /** Monotonic counter for metals quote numbers — only ever increments, never reused. */
    MetalsQuoteCounter = 'metals-quote-counter',
    ObsessedEngineeringData = 'obsessed-engineering-data',
    C3HardwareLabelPrinterId = 'c3-hardware-label-printer-id',
    C3RiderProductId = 'c3-rider-product-id',
    C3AssemblyState = 'c3-assembly-state',
    C3ClearanceInventory = 'c3-clearance-inventory',
    C3InventoryReportEmailConfig = 'c3-inventory-report-email-config',
    LabelPrinterGroups = 'label-printer-groups',
    RaffleDashboardState = 'raffle-dashboard-state',
    RaffleDashboardDisplayStatus = 'raffle-dashboard-display-status',
    RaffleDigitAudio = 'raffle-digit-audio',
}
